import * as React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { Carousel } from '@amzn/dvui/dist/Carousel'
import { ICollection } from '../../selectors/collections'
import { CarouselCollectionItem } from './carouselCollectionItem'
import { IDetailPageState } from '../../reducers'
import { PlaybackContentLink } from '../../../../shared/player'
import { PlaybackArea } from '../../../../shared/player/integration/playbackArea'
import { DetailPageActions } from '../../actions'
import { startPlayback } from '../../actions/player'
import * as cn from 'classnames'
import * as st from './carouselCollectionItem.module.scss'
type OwnProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

interface CarouselState {
  isCarouselFocused: boolean
}

class CarouselCollectionConnected extends React.PureComponent<ICollection & OwnProps, CarouselState> {
  state: CarouselState
  containerRef: React.RefObject<HTMLDivElement>

  constructor(props: ICollection & OwnProps) {
    super(props)
    this.state = {
      isCarouselFocused: false
    }
    this.containerRef = React.createRef()
  }

  setFocusedCarousel(index: number) {
    if (this.props.useNewHover) {
      this.setState({
        isCarouselFocused: index === this.props.index
      })
    }
  }

  resetFocusedCarousel() {
    this.setState({ isCarouselFocused: false })
  }

  componentDidUpdate() {
    // If the carousel contains the focused element, but
    // another has more recently been interacted with, clear
    // the focus, to close the hover (if it's open)
    if (!(this.props.useNewHover && this.state.isCarouselFocused)) {
      const activeElement = document.activeElement as HTMLElement
      const currentContainer = this.containerRef && this.containerRef.current
      if (currentContainer && activeElement && currentContainer.contains(activeElement))
        activeElement.blur()
    }
  }

  render (){
    const { header, cardTitleIds, refTagPrefix,
      useNewHover, totalEpisodeSize, index, usePlayer, startPlayback } = this.props

    if (cardTitleIds.length === 0) {
      return null
    }

    return (
      <div
        className={cn(`dv-hover-packshot-container ${st.collection}`, {
          [st.singleItemCarousel]: totalEpisodeSize === 1
        })}
        ref={this.containerRef}>
        {header && <h1 className={st.title}> {header} </h1>}
        <PlaybackArea usePlayer={usePlayer} onPlay={startPlayback}>
          <Carousel
            className={cn(st.carouselWrapper, {
              [st.newHover]: useNewHover,
              [st.focusedCarousel]: useNewHover && this.state.isCarouselFocused
            })}
            leftScrollButtonClassName={st.scrollButton}
            rightScrollButtonClassName={st.scrollButton}>
            {cardTitleIds.map((titleId, idx) => (
              <CarouselCollectionItem
                key={`carousel-collection-${titleId}-${idx}`}
                idx={idx}
                titleId={titleId}
                refTagPrefix={refTagPrefix}
                requestFocusForCarousel={() => this.setFocusedCarousel(index)}
                resetFocusForCarousel={() => this.resetFocusedCarousel()}
              />
            ))}
          </Carousel>
        </PlaybackArea>
      </div>
    )
  }
}

const mapStateToProps = (
  state: IDetailPageState,
) => ({
  useNewHover: state.features.useNewHover,
  usePlayer: Boolean(state.features.usePlayer)
})

const mapDispatchToProps = (dispatch: Dispatch<DetailPageActions>) => ({
  startPlayback: (playbackContentLink: PlaybackContentLink) =>
    dispatch(startPlayback(playbackContentLink))
})

export const CarouselCollection = connect(mapStateToProps, mapDispatchToProps)(CarouselCollectionConnected)